/** The `plans` area: plans. Owned by the stage 2 slot flows (docs/I18N.md §11).
 *  The keys read in page order: the index, the create form, a plan's page. */
export const plans = {
  // --- The Plans index ---
  'plans.index.title': 'Plans',
  'plans.index.empty': 'No plans yet. Create one to start staging changes.',
  /** The index's sort menu. */
  'plans.sort.recent': 'Recently added',
  'plans.sort.name': 'Name (A–Z)',
  'plans.sort.status': 'Status',
  'plans.sort.menu': 'Sort by',
  'plans.sort.label': 'Sort plans',
  /** A plan's status badge: a draft is still in its planning phase. */
  'plans.status.planning': 'planning',
  'plans.status.executed': 'executed',
  /** The badge on a plan the viewer owns. */
  'plans.badge.mine': 'mine',
  // --- Create a plan ---
  /** The audience choice for a personal plan. */
  'plans.create.justMe': 'Just me',
  'plans.create.placeholder': 'New plan name',
  'plans.create.name': 'Plan name',
  'plans.create.audience': 'Audience',
  'plans.create.submit': 'Create plan',
  // --- A plan's page ---
  'plans.detail.staged': 'Staged changes',
  'plans.detail.empty': 'Nothing staged yet. Open an item and add a change to this plan.',
  /** A staged change's status: applied at execution, still staged in a draft,
   *  raised to its owner as a proposal, declined by that owner, or replaced by
   *  a later change. */
  'plans.change.applied': 'applied',
  'plans.change.staged': 'staged',
  'plans.change.raised': 'raised',
  'plans.change.declined': 'declined',
  'plans.change.superseded': 'superseded',
  'plans.detail.ownerOnly': 'Only the plan owner can execute this plan.',
  'plans.execute.submit': 'Execute plan',
  /** The tally after Execute: changes applied, and changes raised to their owners. */
  'plans.execute.result': {
    one: '{applied} applied directly, {count} raised as request',
    other: '{applied} applied directly, {count} raised as requests',
  },
  'plans.error.groupNeeded': 'A new plan needs a group.',
} as const;
